import { Component, ViewChild, Optional, Inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NgModel, NG_ASYNC_VALIDATORS, ControlContainer, NgForm } from '@angular/forms';
import { BaseControlComponent } from '../base/base-control.component';
@Component({
  // moduleId: module.id,
  selector: 'sep-button',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: ButtonComponent, multi: true }
  ]
})
export class ButtonComponent extends BaseControlComponent<string> {
  @ViewChild(NgModel) model: NgModel;
  @Input() icon: string;
  @Input() size: string;
  constructor(
    @Optional()
    @Inject(NG_VALIDATORS)
    validators: Array<any>,
    @Optional()
    @Inject(NG_ASYNC_VALIDATORS)
    asyncValidators: Array<any>) {
    super(validators, asyncValidators);
  }
}
